var sliders = {
	options: {
		//sliders_instances: [],
	},

  selectors: {
    	reviewsSlider: '.js-sliders-reviews',
  },

	init: function () {
		var self = this;

		self.gallery();
	},

	gallery: function () {
    	const self = this;

		jQuery('.splide').each(function (index, element) {
			const splide = new Splide(element, {
				type        : 'slide',
				perPage     : 2.25,
				perMove     : 1,
				focus       : 0,
				arrows      : false,
				pagination  : true,
				gap         : '30px',
				trimSpace   : false,
				updateOnMove: true,
				cloneStatus : false,
				breakpoints : {
				768: {
					perPage: 1.25,
					gap    : '16px',
				}
				},
			});

			// Store the Splide instance in the DOM element so you can retrieve it on click
			element._splideInstance = splide;

			// Handle slide change -> update active dot manually
			splide.on('move', function (newIndex) {
				const $pagination = jQuery(element).find('.splide__pagination__page');
				$pagination.removeClass('is-active');
				$pagination.eq(newIndex).addClass('is-active');
			});

			splide.mount();
		});

		jQuery(document).on('click', '.splide__pagination__page', function () {
			const $btn = jQuery(this);
			const $slider = $btn.closest('.splide')[0];
			const dotIndex = $btn.parent().index();

			const splide = $slider._splideInstance;
			splide.go( dotIndex );
		});
	},
};

export { sliders };
